import Drum from "../images/Drum.png";
import tindog from "../images/tindog.png";
import Calc from "../images/Calc.png";
import Ecommerce from "../images/Ecommerce.png";
import Ticketbooker from "../images/Ticketbooker.png";
const project = [
  {
    type: "ExpressJS",
    title: "TINDOG",
    href: "https://cocky-jang-126d9e.netlify.app",
    image: tindog
  },
  {
    type: "ExpressJS",
    title: "DRUM KIT",
    href: "https://peaceful-benz-64a420.netlify.app",
    image: Drum
  },
  {
    type: "ReactJS",
    title: "Calculator",
    href: "https://4zgdou.csb.app/",
    image: Calc
  },
  {
    type: "ReactJS",
    title: "E-commerce Shopping Site",
    href: "https://rnc71z.csb.app/",
    image: Ecommerce
  },
  {
    type: "ReactJS",
    title: "TICKET BOOKER",
    href: "https://i4f6yf.csb.app/",
    image: Ticketbooker
  }
];

export default project;
